import { LoadingButton } from '@mui/lab';
import { Autocomplete, Box, Button, Checkbox, Dialog, FormControl, FormControlLabel, InputLabel, MenuItem, Select, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import request from '../../utils/request';

function EndorsementShareModel({ setShareDialogOpen, setCustomEmail, customEmail, createEndorsement, endorsementloader,
    policyData = null
}) {


    const [useCustomEmail, setUseCustomEmail] = useState(false);
    const [branchContactDatas, setBranchContactData] = useState([]);
    const [branchContactSearchValue, setBranchContactSearchValue] = useState('');
    const [branchContactValue, setBranchContactValue] = useState<any>(null);
    const [emailError, setEmailError] = useState('');
    const [branchError, setBranchError] = useState('');

    useEffect(() => {
        if (policyData) {
            fetchCompanyContactList();
        }

    }, [policyData])

    const fetchCompanyContactList = () => {
        request({
            url: 'icb-contacts/getIcbContactList',
            method: 'POST',
            data: {
                search: branchContactSearchValue,
                orderColumn: 'id',
                orderDirection: 'DESC',
                offset: 0,
                limit: 10000,
                branchId: policyData?.insurancePolicy?.insuranceCompanyBranch?.id
            }
        })
            .then((response: any) => {
                setBranchContactData(response?.contactData);
            })
            .catch(function (err) { });
    };

    const validateShareEndorsement = () => {
        setEmailError('');
        setBranchError('');

        if (useCustomEmail) {
            if (!customEmail) {
                setEmailError('Custom Email ID is required');
                return false;
            }
            if (!isValidEmail(customEmail)) {
                setEmailError('Enter a Valid Email ID');
                return false;
            }
        } else {
            if (!branchContactValue) {
                setBranchError('Branch Contact is required');
                return false;
            }
        }

        return true;
    };



    const isValidEmail = (email) =>
        /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const handleSave = () => {
        if (!validateShareEndorsement()) {
            return;
        }

        const payload = {
            policyId: policyData?.id,
            status: 'Endorsement',
            sendMail: true,
            insuranceCompanyId: policyData?.insuranceCompanyId,
            insuranceCompanyBranchId: useCustomEmail ? null : policyData?.branchId,
            insuranceCompanyBranchContact: useCustomEmail ? null : branchContactValue?.id || null,
            otherContact: useCustomEmail ? customEmail : null
        };

        createEndorsement('Endorsement', payload);
        setShareDialogOpen(false);
    };


    return (
        <Dialog open={true} onClose={() => setShareDialogOpen(false)} maxWidth="sm" fullWidth>
            <Box p={3}>
                <Typography variant="h6" mb={2}>Share Endorsement</Typography>              

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={useCustomEmail}
                            onChange={(e) => setUseCustomEmail(e.target.checked)}
                        />
                    }
                    label="Use Custom Email ID"
                />

                {useCustomEmail ? (
                    <TextField
                        fullWidth
                        label={
                            <span>
                                Custom Email ID <span style={{ color: 'red' }}>*</span>
                            </span>
                        }
                        value={customEmail}
                        onChange={(e) => {
                            setCustomEmail(e.target.value);
                            validateShareEndorsement();
                        }}
                        sx={{ mt: 2 }}
                        size='small'
                        error={Boolean(emailError)}
                        helperText={emailError}
                    />
                ) : (
                    <>
                    <FormControl fullWidth sx={{ mt: 2 }}>
                            <Autocomplete
                                size="small"
                                disableClearable
                                id="insuranceCompanyBranchContactId"
                                value={branchContactValue}   // MUST control value
                                options={branchContactDatas}
                                getOptionLabel={(companyData) =>
                                    `${companyData.firstName} ${companyData.lastName} (${companyData.email})`
                                }
                                inputValue={branchContactSearchValue}
                                noOptionsText="No Data Found"
                                onChange={(event, newValue) => {
                                    setBranchContactValue(newValue);

                                    if (newValue) {
                                        setBranchContactSearchValue(newValue.firstName);
                                        setBranchError('');              // hide error immediately
                                    } else {
                                        setBranchContactSearchValue('');
                                    }
                                }}
                                onInputChange={(event, newInputValue, reason) => {
                                    if (reason === 'input') {
                                        setBranchContactSearchValue(newInputValue);

                                        // IMPORTANT: typing does NOT mean valid selection
                                        if (!newInputValue) {
                                            setBranchContactValue(null);
                                        }
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <span>
                                                Insurer Branch Contact <span style={{ color: 'red' }}>*</span>
                                            </span>
                                        }
                                        error={Boolean(branchError)}
                                        helperText={branchError}
                                    />
                                )}
                            />
                        </FormControl>

                    </>
                )}

                <Box display="flex" justifyContent="flex-end" gap={1.5} mt={3}>
                    <LoadingButton
                        size={'small'}
                        loading={endorsementloader}
                        variant="contained"
                        onClick={handleSave}
                    >
                        Save & Create Endorsement
                    </LoadingButton>
                    <Button variant="contained" color="error" size={'small'} onClick={() => setShareDialogOpen(false)}>Cancel</Button>

                </Box>
            </Box>
        </Dialog>

    )
}

export default EndorsementShareModel